import React from 'react';

export const FlagDe = () => {
  return (
    <svg width="51" height="35" viewBox="0 0 51 35" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_430_178)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.44805 0.312622H47.543C49.0418 0.312622 50.2625 1.51679 50.2625 2.99543V31.621C50.2625 33.0907 49.0418 34.2949 47.552 34.3038H3.43907C1.9492 34.3126 0.728577 33.0996 0.728577 31.6298V2.99543C0.728577 1.51679 1.9492 0.312622 3.44805 0.312622Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.728577 11.646H50.2714V31.6298C50.2714 33.1085 49.0508 34.3127 47.552 34.3127H3.44805C1.9492 34.3127 0.728577 33.1085 0.728577 31.6298V11.646Z"
          fill="#DD0000"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.728577 22.9792H50.2714V31.6298C50.2714 33.0996 49.0508 34.3037 47.5609 34.3126H3.44805C2.72753 34.3102 2.03719 34.0268 1.52771 33.5242C1.01822 33.0216 0.730943 32.3406 0.728577 31.6298L0.728577 22.9792Z"
          fill="#FFCE00"
        />
      </g>
      <defs>
        <clipPath id="clip0_430_178">
          <rect width="49.5429" height="34" fill="white" transform="translate(0.728577 0.312622)" />
        </clipPath>
      </defs>
    </svg>
  );
};
